import { useState, useEffect } from "react";
import moment from "moment";
import "./styles.css";
import PageHeader from "../../component/pageHeaders";
import DataTable from "./component/datatable";
import Loadingbox from "../../component/loadingbox";
import { Button, DatePicker, message, Radio, Spin, Tag } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import Preview from "./component/preview";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "../../config/API";
import { DELETE, POST, PUT } from "../../utils/apirequest";
import dayjs from "dayjs";
function EPaperScreeen() {
  const navigation = useNavigate();
  const location = useLocation();
  const [isloading, setIsloading] = useState(true);
  const [data, setData] = useState([]);
  const [item, setItem] = useState({});
  const [preview, setPreview] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [meta, setMeta] = useState();
  const [filter, setFilter] = useState({ start: 0, limit: 10 }) as any;
  const [showDates, setShowDates] = useState(true);
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);
  const [isloading2, setIsloading2] = useState(true);
  const [publishCount, setPublishCount] = useState(0);
  const [scheduledCount, setScheduledCount] = useState(0);
  const [draftCount, setDraftCount] = useState(0);
  const [trashCount, setTrashCount] = useState(0);

  useEffect(() => {
    // Check if there's a date parameter in URL
    const urlParams = new URLSearchParams(location.search);
    const dateParam = urlParams.get("date");

    if (dateParam) {
      // Load editions for the specific date
      setSelectedDate(dayjs(dateParam));
      const filters = { ...filter, date: dateParam };
      setFilter(filters);
      loadData(filters);
    } else {
      // Load dates list
      loadDates(filter);
    }
  }, [location.search]);

  const loadDates = async (filters: any) => {
    try {
      let URL = API.EPAPER_DATE;
      const res: any = await POST(URL, filters);
      if (res?.status) {
        setData(res?.data || []);
        setMeta(res?.count);
        setIsloading(false);
        setShowDates(true);
      } else {
        // *** UPDATED: Handle no data case ***
        setData([]);
        setIsloading(false);
        setShowDates(true);
      }
    } catch (err) {
      setData([]);
      setIsloading(false);
    }
  };

  const loadData = async (filter: any) => {
    try {
      let URL = API.EPAPER_LIST;
      const res: any = await POST(URL, filter);
      if (res?.status) {
        setData(res?.data);
        setMeta(res.count);
        setPublishCount(res.publishedCount ?? 0);
        setScheduledCount(res.scheduledCount ?? 0);
        setDraftCount(res.draftCount ?? 0);
        setTrashCount(res.trashedCount ?? 0);
        setIsloading2(false);
        setIsloading(false);
        setShowDates(false);
      }
    } catch (err) {
      setData([]);
      setIsloading(false);
    }
  };

  const showPreview = (val: any) => {
    setItem(val);
    setPreview(true);
  };

  const editionChange = (category: any) => {
    let filters = {
      ...filter,
      edition: category,
    };
    setFilter(filters);
    loadData(filters);
  };

  const LoadByFilter = (type: any) => {
    let filters = {
      ...filter,
      type: type,
    };
    setFilter(filters);
    loadData(filters);
  };

  const onChangeDate = (date: any, datestring: any) => {
    if (date) {
      let filters = {
        ...filter,
        start: 0,
        date: datestring,
      };
      setPage(1);
      setFilter(filters);
      loadData(filters);
    } else {
      // cleared date → go back to dates list
      const { date: _date, ...rest } = filter || {};
      const filters = { ...rest, start: 0 };
      setPage(1);
      setFilter(filters as any);
      loadDates(filters);
    }
  };

  const onPageChange = (page: any, pageSize: any) => {
    window.scrollTo(0, 0);
    let take = page === 1 ? 0 : (page - 1) * 10;
    setPage(page);
    setPageSize(pageSize);
    let filters = {
      ...filter,
      start: take,
      limit: pageSize,
    };
    if (showDates) {
      loadDates(filters);
    } else {
      loadData(filters);
    }
  };

  const UndoTrash = async (val: any) => {
    let url = API.EPAPER_EDIT + `${val.id}`;
    let obj = {
      data: {
        is_deleted: false,
      },
    };
    let res: any = await PUT(url, obj);
    if (res?.data?.id) {
      message.success("Sucesssfully Recovered from trash");
      loadData(filter);
    } else {
      message.error("Something went wrong...!");
    }
  };

  const addToTrash = async (val: any) => {
    try {
      let url = API.EPAPER_EDIT + `${val.id}`;
      let obj = {
        data: {
          is_deleted: true,
        },
      };
      let res: any = await PUT(url, obj);
      if (res?.data?.id) {
        message.success("Sucesssfully moved to trash");
        loadData(filter);
      } else {
        message.error("Something went wrong...!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onDelete = async (val: any) => {
    try {
      let url = API.EPAPER_DELETE + `${val}`;
      let response: any = await DELETE(url);
      if (response) {
        loadData(filter);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onPageHeaderDateChange = (date: any, datestring: any) => {
    if (date) {
      setSelectedDate(date);
      setIsloading(true);
      let filters = {
        ...filter,
        start: 0,
        date: datestring,
      };
      setPage(1);
      setFilter(filters);
      loadDates(filters); // Call loadDates as requested
    } else {
      setSelectedDate(null);
      const { date: _date, ...rest } = filter || {};
      const filters = { ...rest, start: 0 };
      setPage(1);
      setFilter(filters as any);
      loadDates(filters);
    }
  };

  return (
    <div style={{ height: "90vh", overflow: "scroll" }}>
      <PageHeader
        title={"E-Paper"}
        length={`${data.length} Pages`}
        onBack={() => (showDates ? navigation(-1) : onChangeDate(null, null))}
      >
        <DatePicker
          value={selectedDate}
          onChange={onPageHeaderDateChange}
          placeholder="Select Date"
          style={{ marginRight: 8 }}
          format="YYYY-MM-DD"
          disabledDate={(current) => {
            // Disable future dates
            return current && current > dayjs().endOf("day");
          }}
        />

        <Button
          icon={<ReloadOutlined />}
          onClick={() => {
            setIsloading(true);
            if (showDates) {
              loadDates(filter);
            } else {
              loadData(filter);
            }
          }}
          style={{ marginRight: 8 }}
        >
          Refresh
        </Button>
        <Button
          onClick={() => navigation("/Auth/EpaperCommonPages")}
          style={{ marginRight: 8 }}
        >
          Common Pages
        </Button>
        <Button
          type="primary"
          onClick={() => navigation("/Auth/EpaperForm/create")}
        >
          Add New +
        </Button>
      </PageHeader>

      {isloading ? (
        <Loadingbox />
      ) : (
        <>
          {/* {!showDates && (
            <>
              <div style={{ padding: 4 }} />
              <div className="homescreen-pageItem">
                <div style={{ textTransform: "capitalize" }}>
                  {Object.keys(filter)?.length > 2
                    ? "Filter By :"
                    : "All E-Papers"}{" "}
                  &nbsp;
                  {Object.keys(filter)?.map(
                    (key, index) =>
                      key !== "start" &&
                      key !== "limit" && (
                        <Tag key={index} style={{ marginBottom: 5 }}>
                          {`${key}:  ${
                            key === "createdAt"
                              ? moment(filter[key]).format("DD-MM-YYYY")
                              : filter[key]
                          }`}
                        </Tag>
                      )
                  )}
                </div>
                <div style={{ flex: 1 }} />
                <Radio.Group
                  value={filter?.type}
                  onChange={(val: any) => LoadByFilter(val?.target?.value)}
                >
                  <Radio.Button value="All">
                    <span style={{ color: "green" }}>📊 All</span> - &nbsp;{" "}
                    {isloading2 ? (
                      <Spin size="small" />
                    ) : (
                      publishCount + scheduledCount + trashCount + draftCount
                    )}
                  </Radio.Button>
                  <Radio.Button value="published">
                    <span style={{ color: "green" }}>✅ Published</span>&nbsp;{" "}
                    {isloading2 ? <Spin size="small" /> : publishCount}
                  </Radio.Button>
                  <Radio.Button value="scheduled">
                    <span style={{ color: "orange" }}>⏰ Scheduled</span>&nbsp;{" "}
                    {isloading2 ? <Spin size="small" /> : scheduledCount}
                  </Radio.Button>
                  <Radio.Button value="trash">
                    <span style={{ color: "red" }}>🗑️ Trashed</span>&nbsp;{" "}
                    {isloading2 ? <Spin size="small" /> : trashCount}
                  </Radio.Button>
                  <Radio.Button value="draft">
                    <span style={{ color: "blue" }}>📝 Draft</span>&nbsp;{" "}
                    {isloading2 ? <Spin size="small" /> : draftCount}
                  </Radio.Button>
                </Radio.Group>
              </div>
            </>
          )} */}
          <DataTable
            data={data}
            page={page}
            pagesize={pageSize}
            meta={meta}
            refresh={() => loadData(filter)}
            onTrash={(val: any) => addToTrash(val)}
            unTrash={(val: any) => UndoTrash(val)}
            onDelete={(val: any) => onDelete(val)}
            onEdit={(val: any) => navigation(`/Auth/EpaperForm/${val?.id}`)}
            onPageChange={(page: any, pageSize: any) =>
              onPageChange(page, pageSize)
            }
            showPreview={(val: any) => showPreview(val)}
            mode={showDates ? "date" : "epaper"}
            onSelectDate={(val: string) => {
              setIsloading(true);
              onChangeDate(val, moment(val).format("YYYY-MM-DD"));
            }}
          />
        </>
      )}
      {preview ? (
        <Preview
          item={item}
          open={preview}
          onCancel={() => setPreview(false)}
        />
      ) : null}
    </div>
  );
}

export default EPaperScreeen;
